export type County = {
    value: string;
    label: string;
};
export const Counties: County[] = [
    { value: 'Abnaki', label: 'Abnaki' },
    { value: 'Achinese', label: 'Achinese' },
    { value: 'Achumawi', label: 'Achumawi' },
    { value: 'African', label: 'African' },
    { value: 'Afrikaans', label: 'Afrikaans' },
    { value: 'Ahtena', label: 'Ahtena' },
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Albanian', label: 'Albanian' },
    { value: 'Aleut', label: 'Aleut' },
    { value: 'Algonquian', label: 'Algonquian' },
    { value: 'American Indian', label: 'American Indian' },
    { value: 'Amharic', label: 'Amharic' },
    { value: 'Apache', label: 'Apache' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Arapaho', label: 'Arapaho' },
    { value: 'Arawakian', label: 'Arawakian' },
    { value: 'Arikara', label: 'Arikara' },
    { value: 'Armenian', label: 'Armenian' },
    { value: 'Assamese', label: 'Assamese' },
    { value: 'Athapascan', label: 'Athapascan' },
    { value: 'Atsina', label: 'Atsina' },
    { value: 'Atsugewi', label: 'Atsugewi' },
    { value: 'Aymara', label: 'Aymara' },
    { value: 'Azerabaijani', label: 'Azerabaijani' },
    { value: 'Aztecan', label: 'Aztecan' },
    { value: 'Balinese', label: 'Balinese' },
    { value: 'Balochi', label: 'Balochi' },
    { value: 'Bantu', label: 'Bantu' },
    { value: 'Basque', label: 'Basque' },
    { value: 'Bengali', label: 'Bengali' },
    { value: 'Berber', label: 'Berber' },
    { value: 'Bielorussian', label: 'Bielorussian' },
    { value: 'Bihari', label: 'Bihari' },
    { value: 'Bikol', label: 'Bikol' },
    { value: 'Bisayan', label: 'Bisayan' },
    { value: 'Blackfoot', label: 'Blackfoot' },
    { value: 'Bulgarian', label: 'Bulgarian' },
    { value: 'Burmese', label: 'Burmese' },
    { value: 'Caddo', label: 'Caddo' },
    { value: 'Cahuilla', label: 'Cahuilla' },
    { value: 'Cajun', label: 'Cajun' },
    { value: 'Cambodian', label: 'Cambodian' },
    { value: 'Cantonese', label: 'Cantonese' },
    { value: 'Carolinian', label: 'Carolinian' },
    { value: 'Catalonian', label: 'Catalonian' },
    { value: 'Cayuga', label: 'Cayuga' },
    { value: 'Chadic', label: 'Chadic' },
    { value: 'Cham', label: 'Cham' },
    { value: 'Chamorro', label: 'Chamorro' },
    { value: 'Chasta Costa', label: 'Chasta Costa' },
    { value: 'Chemehuevi', label: 'Chemehuevi' },
    { value: 'Cherokee', label: 'Cherokee' },
    { value: 'Chetemacha', label: 'Chetemacha' },
    { value: 'Cheyenne', label: 'Cheyenne' },
    { value: 'Chibchan', label: 'Chibchan' },
    { value: 'Chinese', label: 'Chinese' },
    { value: 'Chinook Jargon', label: 'Chinook Jargon' },
    { value: 'Chiricahua', label: 'Chiricahua' },
    { value: 'Chiwere', label: 'Chiwere' },
    { value: 'Choctaw', label: 'Choctaw' },
    { value: 'Chumash', label: 'Chumash' },
    { value: 'Clallam', label: 'Clallam' },
    { value: 'Cocomaricopa', label: 'Cocomaricopa' },
    { value: 'Coeur D\'alene', label: 'Coeur D\'alene' },
    { value: 'Columbia', label: 'Columbia' },
    { value: 'Comanche', label: 'Comanche' },
    { value: 'Cowlitz', label: 'Cowlitz' },
    { value: 'Cree', label: 'Cree' },
    { value: 'Croatian', label: 'Croatian' },
    { value: 'Crow', label: 'Crow' },
    { value: 'Cupeno', label: 'Cupeno' },
    { value: 'Cushite', label: 'Cushite' },
    { value: 'Czech', label: 'Czech' },
    { value: 'Dakota', label: 'Dakota' },
    { value: 'Danish', label: 'Danish' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Delta River Yuman', label: 'Delta River Yuman' },
    { value: 'Diegueno', label: 'Diegueno' },
    { value: 'Dravidian', label: 'Dravidian' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'Efik', label: 'Efik' },
    { value: 'English', label: 'English' },
    { value: 'Eskimo', label: 'Eskimo' },
    { value: 'Estonian', label: 'Estonian' },
    { value: 'Faroese', label: 'Faroese' },
    { value: 'Fijian', label: 'Fijian' },
    { value: 'Finnish', label: 'Finnish' },
    { value: 'Foothill North Yokuts', label: 'Foothill North Yokuts' },
    { value: 'Formosan', label: 'Formosan' },
    { value: 'Fox', label: 'Fox' },
    { value: 'French', label: 'French' },
    { value: 'French Cree', label: 'French Cree' },
    { value: 'Frisian', label: 'Frisian' },
    { value: 'Fuchow', label: 'Fuchow' },
    { value: 'Fulani', label: 'Fulani' },
    { value: 'German', label: 'German' },
    { value: 'Gilbertese', label: 'Gilbertese' },
    { value: 'Gondi', label: 'Gondi' },
    { value: 'Greek', label: 'Greek' },
    { value: 'Gujarati', label: 'Gujarati' },
    { value: 'Gullah', label: 'Gullah' },
    { value: 'Gur', label: 'Gur' },
    { value: 'Haida', label: 'Haida' },
    { value: 'Hakka', label: 'Hakka' },
    { value: 'Havasupai', label: 'Havasupai' },
    { value: 'Hawaiian', label: 'Hawaiian' },
    { value: 'Hawaiian Pidgin', label: 'Hawaiian Pidgin' },
    { value: 'Hebrew', label: 'Hebrew' },
    { value: 'Hidatsa', label: 'Hidatsa' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Hmong', label: 'Hmong' },
    { value: 'Hopi', label: 'Hopi' },
    { value: 'Hungarian', label: 'Hungarian' },
    { value: 'Hupa', label: 'Hupa' },
    { value: 'Icelandic', label: 'Icelandic' },
    { value: 'Ilocano', label: 'Ilocano' },
    { value: 'Indonesian', label: 'Indonesian' },
    { value: 'Ingalit', label: 'Ingalit' },
    { value: 'Inupik', label: 'Inupik' },
    { value: 'Irish Gaelic', label: 'Irish Gaelic' },
    { value: 'Iroquois', label: 'Iroquois' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Jamaican Creole', label: 'Jamaican Creole' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Javanese', label: 'Javanese' },
    { value: 'Jicarilla', label: 'Jicarilla' },
    { value: 'Kachin', label: 'Kachin' },
    { value: 'Kan, Hsiang', label: 'Kan, Hsiang' },
    { value: 'Kannada', label: 'Kannada' },
    { value: 'Kansa', label: 'Kansa' },
    { value: 'Karachay', label: 'Karachay' },
    { value: 'Karen', label: 'Karen' },
    { value: 'Karok', label: 'Karok' },
    { value: 'Kashmiri', label: 'Kashmiri' },
    { value: 'Kazakh', label: 'Kazakh' },
    { value: 'Keres', label: 'Keres' },
    { value: 'Khoisan', label: 'Khoisan' },
    { value: 'Kickapoo', label: 'Kickapoo' },
    { value: 'Kiowa', label: 'Kiowa' },
    { value: 'Kirghiz', label: 'Kirghiz' },
    { value: 'Klamath', label: 'Klamath' },
    { value: 'Koasati', label: 'Koasati' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Koyukon', label: 'Koyukon' },
    { value: 'Krio', label: 'Krio' },
    { value: 'Kru, Ibo, Yoruba', label: 'Kru, Ibo, Yoruba' },
    { value: 'Kuchin', label: 'Kuchin' },
    { value: 'Kurdish', label: 'Kurdish' },
    { value: 'Kusaiean', label: 'Kusaiean' },
    { value: 'Kutenai', label: 'Kutenai' },
    { value: 'Kwakiutl', label: 'Kwakiutl' },
    { value: 'Ladino', label: 'Ladino' },
    { value: 'Laotian', label: 'Laotian' },
    { value: 'Lettish', label: 'Lettish' },
    { value: 'Lithuanian', label: 'Lithuanian' },
    { value: 'Luiseno', label: 'Luiseno' },
    { value: 'Lusatian', label: 'Lusatian' },
    { value: 'Luxembourgian', label: 'Luxembourgian' },
    { value: 'Macedonian', label: 'Macedonian' },
    { value: 'Makah', label: 'Makah' },
    { value: 'Malagasy', label: 'Malagasy' },
    { value: 'Malay', label: 'Malay' },
    { value: 'Malayalam', label: 'Malayalam' },
    { value: 'Mandan', label: 'Mandan' },
    { value: 'Mandarin', label: 'Mandarin' },
    { value: 'Mande', label: 'Mande' },
    { value: 'Maori', label: 'Maori' },
    { value: 'Mapuche', label: 'Mapuche' },
    { value: 'Marathi', label: 'Marathi' },
    { value: 'Marquesan', label: 'Marquesan' },
    { value: 'Marshallese', label: 'Marshallese' },
    { value: 'Mayan languages', label: 'Mayan languages' },
    { value: 'Mbum', label: 'Mbum' },
    { value: 'Melanesian', label: 'Melanesian' },
    { value: 'Menomini', label: 'Menomini' },
    { value: 'Miami', label: 'Miami' },
    { value: 'Miao-yao, Mien', label: 'Miao-yao, Mien' },
    { value: 'Micmac', label: 'Micmac' },
    { value: 'Micronesian', label: 'Micronesian' },
    { value: 'Mikasuki', label: 'Mikasuki' },
    { value: 'Misumalpan', label: 'Misumalpan' },
    { value: 'Mohave', label: 'Mohave' },
    { value: 'Mohawk', label: 'Mohawk' },
    { value: 'Mokilese', label: 'Mokilese' },
    { value: 'Mongolian', label: 'Mongolian' },
    { value: 'Mono', label: 'Mono' },
    { value: 'Mortlockese', label: 'Mortlockese' },
    { value: 'Mountain Maidu', label: 'Mountain Maidu' },
    { value: 'Munda', label: 'Munda' },
    { value: 'Muskogee', label: 'Muskogee' },
    { value: 'Navajo', label: 'Navajo' },
    { value: 'Nepali', label: 'Nepali' },
    { value: 'Nez Perce', label: 'Nez Perce' },
    { value: 'Nilo-hamitic', label: 'Nilo-hamitic' },
    { value: 'Nilotic', label: 'Nilotic' },
    { value: 'Niuean', label: 'Niuean' },
    { value: 'Nomlaki', label: 'Nomlaki' },
    { value: 'Nootka', label: 'Nootka' },
    { value: 'Northern Paiute', label: 'Northern Paiute' },
    { value: 'Northwest Maidu', label: 'Northwest Maidu' },
    { value: 'Norwegian', label: 'Norwegian' },
    { value: 'Nubian', label: 'Nubian' },
    { value: 'Nukuoro', label: 'Nukuoro' },
    { value: 'Ojibwa', label: 'Ojibwa' },
    { value: 'Okanogan', label: 'Okanogan' },
    { value: 'Omaha', label: 'Omaha' },
    { value: 'Oneida', label: 'Oneida' },
    { value: 'Onondaga', label: 'Onondaga' },
    { value: 'Oriya', label: 'Oriya' },
    { value: 'Osage', label: 'Osage' },
    { value: 'Oto - Manguen', label: 'Oto - Manguen' },
    { value: 'Ottawa', label: 'Ottawa' },
    { value: 'Pacific Gulf Yupik', label: 'Pacific Gulf Yupik' },
    { value: 'Paiute', label: 'Paiute' },
    { value: 'Palau', label: 'Palau' },
    { value: 'Paleo-siberian', label: 'Paleo-siberian' },
    { value: 'Pampangan', label: 'Pampangan' },
    { value: 'Pangasinan', label: 'Pangasinan' },
    { value: 'Panjabi', label: 'Panjabi' },
    { value: 'Papia Mentae', label: 'Papia Mentae' },
    { value: 'Pashto', label: 'Pashto' },
    { value: 'Passamaquoddy', label: 'Passamaquoddy' },
    { value: 'Patois', label: 'Patois' },
    { value: 'Pawnee', label: 'Pawnee' },
    { value: 'Pennsylvania Dutch', label: 'Pennsylvania Dutch' },
    { value: 'Penobscot', label: 'Penobscot' },
    { value: 'Persian', label: 'Persian' },
    { value: 'Pidgin', label: 'Pidgin' },
    { value: 'Pima', label: 'Pima' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Polynesian', label: 'Polynesian' },
    { value: 'Pomo', label: 'Pomo' },
    { value: 'Ponapean', label: 'Ponapean' },
    { value: 'Ponca', label: 'Ponca' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Potawatomi', label: 'Potawatomi' },
    { value: 'Puget Sound Salish', label: 'Puget Sound Salish' },
    { value: 'Quechua', label: 'Quechua' },
    { value: 'Quinault', label: 'Quinault' },
    { value: 'Rajasthani', label: 'Rajasthani' },
    { value: 'Rarotongan', label: 'Rarotongan' },
    { value: 'Rhaeto-romanic', label: 'Rhaeto-romanic' },
    { value: 'Romanian', label: 'Romanian' },
    { value: 'Romany', label: 'Romany' },
    { value: 'Russian', label: 'Russian' },
    { value: 'Sahaptian', label: 'Sahaptian' },
    { value: 'Saharan', label: 'Saharan' },
    { value: 'Salish', label: 'Salish' },
    { value: 'Samoan', label: 'Samoan' },
    { value: 'Santiam', label: 'Santiam' },
    { value: 'Saramacca', label: 'Saramacca' },
    { value: 'Scottic Gaelic', label: 'Scottic Gaelic' },
    { value: 'Sebuano', label: 'Sebuano' },
    { value: 'Seneca', label: 'Seneca' },
    { value: 'Serbian', label: 'Serbian' },
    { value: 'Serbocroatian', label: 'Serbocroatian' },
    { value: 'Serrano', label: 'Serrano' },
    { value: 'Shawnee', label: 'Shawnee' },
    { value: 'Shoshoni', label: 'Shoshoni' },
    { value: 'Sierra Miwok', label: 'Sierra Miwok' },
    { value: 'Sindhi', label: 'Sindhi' },
    { value: 'Sinhalese', label: 'Sinhalese' },
    { value: 'Siuslaw', label: 'Siuslaw' },
    { value: 'Slovak', label: 'Slovak' },
    { value: 'Slovene', label: 'Slovene' },
    { value: 'Sonoran', label: 'Sonoran' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'Spokane', label: 'Spokane' },
    { value: 'St Lawrence Island Yupik', label: 'St Lawrence Island Yupik' },
    { value: 'Sudanic', label: 'Sudanic' },
    { value: 'Swahili', label: 'Swahili' },
    { value: 'Swedish', label: 'Swedish' },
    { value: 'Syriac', label: 'Syriac' },
    { value: 'Tachi', label: 'Tachi' },
    { value: 'Tadzhik', label: 'Tadzhik' },
    { value: 'Tagalog', label: 'Tagalog' },
    { value: 'Tamil', label: 'Tamil' },
    { value: 'Tanaina', label: 'Tanaina' },
    { value: 'Tarascan', label: 'Tarascan' },
    { value: 'Telugu', label: 'Telugu' },
    { value: 'Tewa', label: 'Tewa' },
    { value: 'Thai', label: 'Thai' },
    { value: 'Tibetan', label: 'Tibetan' },
    { value: 'Tiwa', label: 'Tiwa' },
    { value: 'Tlingit', label: 'Tlingit' },
    { value: 'Tokelauan', label: 'Tokelauan' },
    { value: 'Tongan', label: 'Tongan' },
    { value: 'Tonkawa', label: 'Tonkawa' },
    { value: 'Towa', label: 'Towa' },
    { value: 'Trukese', label: 'Trukese' },
    { value: 'Tsimshian', label: 'Tsimshian' },
    { value: 'Tungus', label: 'Tungus' },
    { value: 'Tupi-guarani', label: 'Tupi-guarani' },
    { value: 'Turkish', label: 'Turkish' },
    { value: 'Turkmen', label: 'Turkmen' },
    { value: 'Tuscarora', label: 'Tuscarora' },
    { value: 'Uighur', label: 'Uighur' },
    { value: 'Ukrainian', label: 'Ukrainian' },
    { value: 'Ulithean', label: 'Ulithean' },
    { value: 'Upper Chinook', label: 'Upper Chinook' },
    { value: 'Urdu', label: 'Urdu' },
    { value: 'Ute', label: 'Ute' },
    { value: 'Vietnamese', label: 'Vietnamese' },
    { value: 'Walapai', label: 'Walapai' },
    { value: 'Washo', label: 'Washo' },
    { value: 'Welsh', label: 'Welsh' },
    { value: 'Wichita', label: 'Wichita' },
    { value: 'Winnebago', label: 'Winnebago' },
    { value: 'Wintun', label: 'Wintun' },
    { value: 'Woleai-ulithi', label: 'Woleai-ulithi' },
    { value: 'Wu', label: 'Wu' },
    { value: 'Yapese', label: 'Yapese' },
    { value: 'Yaqui', label: 'Yaqui' },
    { value: 'Yavapai', label: 'Yavapai' },
    { value: 'Yiddish', label: 'Yiddish' },
    { value: 'Yuchi', label: 'Yuchi' },
    { value: 'Yuma', label: 'Yuma' },
    { value: 'Yupik', label: 'Yupik' },
    { value: 'Yurok', label: 'Yurok' },
    { value: 'Zuni', label: 'Zuni' },
];
